// dependencies
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

// styling
import "./NavBar.css";

// images/icons
import Logo from "../resources/images/logo.png";
import HamburgerIcon from "../resources/images/icons/hamburger.svg";

export default function NavBar() {
  const [mobileNavBarOpen, setMobileNavBarOpen] = useState(false);
  const navigate = useNavigate();

  function toggleMobileNavBar() {
    // check width against mobile breakpoint
    if (window.innerWidth <= 600) {
      setMobileNavBarOpen(!mobileNavBarOpen);
    }
  }

  function toTop() {
    window.scrollTo(0, 0);
    toggleMobileNavBar();
  }

  return (
    <div className="navigation-bar">
      <div
        onClick={() => {
          navigate("/");

          if (mobileNavBarOpen) setMobileNavBarOpen(false);
        }}
        className="branding">
        <img src={Logo} alt="Team ZMotion" />
        <div className="team-details">
          <span className="team-name">Team ZMotion</span>
          <span className="year">Fall 2022 - Spring 2023 Capstone</span>
        </div>
      </div>
      <div onClick={toggleMobileNavBar} className="navigation-toggle-button">
        <img src={HamburgerIcon} alt="Expand Navigation Bar" />
      </div>
      <div
        className={"navigation-options" + (mobileNavBarOpen ? "" : " hidden")}>
        <Link onClick={toTop} to="/">
          Home
          <hr />
        </Link>
        <Link onClick={toTop} to="/information">
          Information
          <hr />
        </Link>
        <Link onClick={toTop} to="/documents-videos">
          Documents & Videos
          <hr />
        </Link>
      </div>
    </div>
  );
}
